export class KundDetailsModalTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        huvudkod: "Huvudkod",
        internnummer: "Internnummer",
        telefon: "Telefon",
        uppdaterad: "Uppdaterad",
        limeId: "Lime Id",
        statusILime: "Status i Lime",
        organisationsnummer: "Organisationsnummer",
        avtalsansvarig: "Avtalsansvarig",
        avdelning: "Avdelning",
        besoksadress: "Besöksadress",
        postadress: "Postadress",
        landOchLandskod: "Land och landskod",
        beskrivning: "Beskrivning",
        aktivILime: "Aktiv i Lime",
        inaktivILime: "Inaktiv i Lime",
        leaveHeader: "Osparade förändringar",
        leaveBody: "Om du lämnar så kommer förändringarna inte sparas",
        dolj: "Dölj",
        kopplaTill: "Koppla till",
        koppladeKunder: "Kopplad till"
    };
}
